<div>
  <div class="info-title">{{ 'createPoint.title.joinedFiles' | translate }}</div>
  <section class="mt-1">
    <div class="d-flex w-100">
      <div class="d-flex gap-2 align-items-center ms-auto">
        <span>
          <p-fileUpload #fubauto1 multiple="multiple" mode="basic" class="buttonUpload__left" accept="application/pdf"
            (onSelect)="onFilesUploaded($event, true)" [auto]="true"
            [chooseLabel]="'btn.importAnnexe' | translate"></p-fileUpload>
        </span>
        <span>
          <p-fileUpload #fubauto2 multiple="multiple" mode="basic" (onSelect)="onFilesUploaded($event, false)"
            [auto]="true" [chooseLabel]="'btn.importAssociate' | translate"></p-fileUpload>
        </span>
      </div>


    </div>
  </section>
</div>
<i-dragndrop [droppableAreas]="droppableAreas()" (onareadrop)="onFileDropped($event)">
  <super-table id="super-files-tables" class="tableFile" #superTableFiles [items]="files" [columns]="columnsFiles"
    id="fileTable" [height]="'calc(100vh - 340px)'" (onClickDelete)="deleteSelectionFiles($event)"
    [hideDeleteSelection]="fileRights?.files.delete === false" (onClickRow)="downloadFile($event)" [multiselect]="true"
    [forselection]="actions" [menu]="filesMenu" (menuItemsRowClick)="receive_menu_Files($event); openMenu($event)">
  </super-table>
</i-dragndrop>


<skeleton-table *ngIf="!hasLoaded" [items]="columnsFiles"></skeleton-table>


<p-dialog styleClass="super-compos-modal-content" [(visible)]="openModification" [modal]="true"
  [style]="{ width: '50vw' }" appendTo="body" [closable]="false">
  <p-header>
    <div class="d-flex align-items-center justify-content-between">
      <h5 class="modal-title super-compos-modal-title">
        {{ 'fileModification' | translate }}
      </h5>
      <div class="d-flex">
        <super-button styleClass="blue" (click)="openModification = false"
          [text]="'btn.cancel' | translate"></super-button>
        <super-button styleClass="green ms-3" (click)="submitModificationFile()" text="Confirmer"></super-button>
      </div>
    </div>
  </p-header>
  <div [formGroup]="formFilesModification">
    <div class="row">
      <div class="col-md-9 mb-2">
        <label class="input-label d-block">{{ 'global.title' | translate }}/ {{ 'description' | translate }}</label>
        <input type="text" pInputText formControlName="description" class="w-100" />
      </div>
      <div class="col-md-3 mb-2">
        <label class="input-label d-block">{{ 'displayOrder' | translate }}</label>
        <input type="text" pInputText formControlName="OrdreAffichage" class="w-100" />
      </div>
      <div class="col-md-2">
        <label class="input-label d-block mb-2">{{ 'fileType' | translate }} <i class="fas fa-info-circle smallIcon"
            [pTooltip]="getTooltipContent()"></i></label>
        <div class="d-flex align-items-center justify-content-start">
          <label class="input-label me-2">{{ 'annex' | translate }}</label>
          <p-inputSwitch [readonly]="isAnnexReadonly()" (onChange)="changeTypeOfFileInModification($event)"
            formControlName="annexe"></p-inputSwitch>
        </div>
      </div>
      <div class="col-md-2" *ngIf="formFilesModification.value.annexe === true">
        <label class="input-label d-block">{{ 'annexNumber' | translate }} *</label>
        <input type="number" pInputText formControlName="annexeNumero" class="w-100" />
      </div>
      <div class="col-md-4" *ngIf="globalElement.configApp.delibConfig.isiDelibeMandatairesEnabled">
        <label class="input-label d-block">{{ 'webVisibility._' | translate }} : {{ 'webVisibility.mandataire' |
          translate }}</label>
        <p-checkbox [label]="'webVisibility.mandataire' | translate" binary="true"
          formControlName="visibleDelibeWeb"></p-checkbox>
      </div>
      <div class="col-md-4" *ngIf="globalElement.configApp.delibConfig.isiDelibeCitoyensEnabled">
        <label class="input-label d-block">{{ 'webVisibility._' | translate }} : {{ 'webVisibility.citoyen' | translate
          }}</label>
        <p-checkbox [label]="'webVisibility.citoyen' | translate" binary="true"
          formControlName="visibleDelibeWebCitoyen"></p-checkbox>
      </div>
    </div>
  </div>
</p-dialog>

<p-confirmDialog #cd appendTo="body" styleClass="super-compos-modal-content confirmModal" header="Confirmation"
  icon="pi pi-exclamation-triangle" key="file">
  <p-footer>
    <button type="button" pButton icon="pi pi-times" label="Non" (click)="cd.reject()"></button>
    <button class="pButtonRed" type="button" pButton icon="pi pi-check" label="Oui" (click)="cd.accept()"></button>
  </p-footer>
</p-confirmDialog>
<p-dialog styleClass="super-compos-modal-content" [(visible)]="confirmDialogBool" [modal]="true"
  [style]="{ width: '30vw' }" appendTo="body" [closable]="false">
  <p-header>
    <div class="d-flex align-items-center justify-content-between">
      <h5 class="modal-title super-compos-modal-title">Confirmation</h5>
      <div class="d-flex">
        <super-button styleClass="blue" (click)="confirmDialogBool = false"
          [text]="'btn.close' | translate"></super-button>
      </div>
    </div>
  </p-header>
  <section>
    <p>
      Souhaitez-vous ajouter le/les fichiers <b><u>PDF</u></b> comme annexe(s) ?
    </p>
    <p>
      Attention cela ne concerne pas les autres extensions de fichiers qui sont toutes considérées comme des fichiers
      associés.
    </p>
    <div class="d-flex align-items-center justify-content-end">
      <!-- 1st part of the modal directly accessed when its opened -->
      <super-button styleClass="red me-2" (click)="addFileAnnexe(false)" [text]="'Refuser'"></super-button>
      <super-button styleClass="green" (click)="addFileAnnexe(true)" [text]="'Confirmer'"></super-button>
    </div>
  </section>
</p-dialog>

<p-sidebar [(visible)]="modalPdfViewer" position="right" [style]="{ width: '50vw' }">
  <section>
    <i-viewer *ngIf="currentFileForViewer" [file]="currentFileForViewer" [viewerConfig]="pdfViewerConfig"
      style="height: 100vh; display: block;"></i-viewer>
  </section>
</p-sidebar>